'use client';

import Script from 'next/script';
import { FC, useState } from 'react';

import { getSigninUrl } from 'src/authentication/components/SSO/ssoHelper';
import { COOKIE_USER_TOKEN } from 'src/constants/cookie.constants';

export const GoogleOneTap: FC = () => {
  const [loginUrl] = useState<string | null>(() => {
    if (globalThis.window === undefined) {
      return null;
    }
    const signinUrl = getSigninUrl(globalThis.window.location.toString());
    const loginQueryParams = new URLSearchParams({
      state: btoa(signinUrl),
    });
    const loginUrlBase = new URL('/api/auth/google/one-tap', globalThis.window.location.toString());
    return `${loginUrlBase}?${loginQueryParams.toString()}`;
  });

  return (
    <>
      <Script src="https://accounts.google.com/gsi/client" key="googleSso" strategy="lazyOnload" />
      {!!loginUrl && (
        <div
          id="g_id_onload"
          data-client_id={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}
          data-login_uri={loginUrl}
          data-itp_support="true"
          data-skip_prompt_cookie={COOKIE_USER_TOKEN}
        />
      )}
    </>
  );
};
